// Category Picker Component 

<template>
	<div class="cat-pick-main">
		<!-- {{ compData.step }} -->
		<div class="item" v-for="(item, idx) in cats" :key="'cat_' + idx">
			<div class="btn" :id="'btn_' + item.itemId"  :ref="'btn_' + item.itemId" @click="goClickItem(item)" v-if="item.pub=='1'">
				<div class="btn-img">
					<img :src="calcImgUrl('min', item.icoMin)" v-if="item.icoMin" />
				</div>
				<div class="btn-title">
					{{item.title}} 
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { mapState } from 'vuex';
import { eventBus } from '@/main';

export default {
	props: {
		compData: { 
			step: Object, 
			default: function () {
				return {
					step:"current"
				}
			} 
		},
	},
	methods: {

		goClickItem(item) {
			m("go click item: " + item.title);

			m("refs", this.$refs);
			this.goFlash(item.itemId);
			
			const payload = {
				step: this.compData.step,
				cat: item,
			}
			this.$store.dispatch('app/setCat', payload); // Set category

			if (this.compData.modal) {
				eventBus.$emit("popclose");	// Close popup	
			}

		},

		goFlash(id) {
			const refId = 'btn_' + id;
			m("flash: " + refId);

			const el = document.getElementById(refId);
			// const el = this.$refs[refId];
			m("el: " + typeof el, el);

			el.className = "btn btn-flash";
			setTimeout(() => {
				el.className = "btn";
			}, 200);

		},
		calcImgUrl(iType, fileName) {
			return this.source.url + this.source.ico + 'cat/' + iType + '/' + fileName;
		},
	},
	computed: {
		...mapState('api', ['source']),
		...mapState('app', ['cats']),
	},
	mounted() {
		m("cat pick mounted", this.compData);
	}
}
</script>

<style scoped>
	.cat-pick-main {
		height: 100%;
		overflow: hidden;
		background-color: #FFF;
		padding: 0px 0px 0px 20px;
		border: solid 0px #369;
	}
	.item {
		height: 40px;
		overflow: hidden;
		border: solid 0px #090;
	}
	.btn {
		width: 180px;
		height: 38px;
		overflow: hidden;
		white-space: nowrap;
		font-family: inherit;
		font-size: 16px; 
		text-align: left;
		cursor: pointer;
		padding: 1px 0px 0px 10px;
		background-color: #DDD;
		border: solid 1px #999;		
		border-top: solid 2px #FFF;
		border-left: solid 2px #FFF;
		/* border-radius: 4px; */
		border-bottom-right-radius: 8px;
	}
	.btn-img {
		display: inline-block;
		width: 32px;
		height: 32px;
		overflow: hidden;
		border: solid 0px #66C;		
	}
	.btn-title {
		display: inline-block;
		width: 130px;
		height: 30px;
		overflow: hidden;
		white-space: nowrap;
		text-align: left;
		vertical-align: top;
		padding: 6px 0px 0px 15px;
		border: solid 0px #C60;		
	}
	.btn-flash {
		background-color: #CCC;
	}
</style>
